import React from 'react'
import Reflux from 'reflux'
import {
	Card,
	CardBody,
	CardTitle,
	Table
} from 'reactstrap'
import _ from 'lodash'

import IngredientsTypesStore from '~/stores/ingredientsTypes.js'
// import IngredientsTypesActions from '~/actions/ingredientsTypes.js'
import ModalIngredientListRow from '~/modules/modals/ingredientsTypes/listRow.jsx'


export default class RecipeIngredientsTypesModalList extends Reflux.Component {
	constructor(props) {
		super(props)

		this.store = IngredientsTypesStore
	}

	render() {
		const ingredientTypesList = (
			_.has(this.state, 'ingredientsTypes')
			&& _.size(this.state.ingredientsTypes) > 0
		)
			? this.state.ingredientsTypes.map(
				theIngredientType => (
					<ModalIngredientListRow
						key={theIngredientType.ingredientTypeID}
						ingredientTypeID={theIngredientType.ingredientTypeID}
						ingredientType={theIngredientType.ingredientType}
					/>
				)
			)
			: null

		return (
			<Card body inverse color="secondary">
				<CardTitle>
					Existing Ingredients Types
				</CardTitle>
				<CardBody style={{ margin: 0, padding: 0 }}>
					<br />

					<Table size="sm" striped>
						<thead>
							<tr>
								<th style={{ width: '80%' }}>Ingredient Type</th>
								<th style={{ width: '10%' }} />
								<th style={{ width: '10%' }} />
							</tr>
						</thead>
						<tbody>
							{ingredientTypesList}
						</tbody>
					</Table>
				</CardBody>
			</Card>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modals/ingredientsTypes/list.jsx